const Logger = {
  log: (message: string) => {
    console.log(message);
  }
};

export default Logger;
